import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from 'src/components/ui/accordion';
import React from 'react';
import { clsx } from 'clsx';
import { CheckIcon } from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep2/CheckIcon/CheckIcon';
import { AddItemIcon } from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep2/AddItemIcon/AddItemIcon';
import { useAppSelector } from 'src/store';
import { DeleteKnowledgeBaseIntegrationModal } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/delete/DeleteKnowledgeBaseIntegrationModal/DeleteKnowledgeBaseIntegrationModal';
import { EditKnowledgeBaseIntegrationModal } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/edit/EditKnowledgeBaseIntegrationModal/EditKnowledgeBaseIntegrationModal';
import { AddZendeskTicketsPopup } from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep2/ZendeskTicketsAccordion/AddZendeskTicketsPopup/AddZendeskTicketsPopup';
import { AddItemIconDisabled } from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep2/AddItemIcon/AddItemIconDisabled';

export const ZendeskTicketsAccordion = ({
  item = null,
  isButtonsDisabled = false,
  knowledgeBase,
}) => {
  const [value, setValue] = React.useState('');
  const disabled = !item;

  return (
    <div className={clsx('w-full flex flex-row items-start gap-5')}>
      <div className={'pt-5'}>
        <CheckIcon className={clsx(!disabled ? 'visible' : 'invisible')} />
      </div>
      <Accordion
        value={value}
        onValueChange={setValue}
        type="single"
        className="w-full max-w-[455px] min-w-[455px]"
        collapsible={false}
        disabled={disabled}
      >
        <AccordionItem
          value="new-card"
          className={clsx(
            'group border border-[#B8C1C633] rounded-sm-5 bg-white transition-shadow shadow-none',
            !disabled && 'hover:shadow-[0_2px_2px_rgba(0,0,0,0.25)]',
          )}
        >
          <AccordionTrigger hideDefaultIcon className="py-2.5 px-5 cursor-default">
            <div className="flex items-center justify-between w-full">
              <div className={'flex flex-row gap-[7px] w-full'}>
                <div className={'pt-[4px]'}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="11"
                    viewBox="0 0 15 11"
                    fill="none"
                  >
                    <path
                      d="M6.92308 2.90453V11.001H0L6.92308 2.90453ZM6.92308 0.000976562C6.92308 1.84362 5.36538 3.35123 3.46154 3.35123C1.55769 3.35123 0 1.84362 0 0.000976562H6.92308ZM8.07692 11.001C8.07692 9.15834 9.63461 7.65072 11.5385 7.65072C13.4423 7.65072 15 9.15834 15 11.001H8.07692ZM8.07692 8.09742V0.000976562H15L8.07692 8.09742Z"
                      fill="#05050D"
                    />
                  </svg>
                </div>
                <div className={'flex flex-row w-full justify-between'}>
                  <div className={'text-start'}>
                    <p className={'text-ebony text-sm font-semibold'}>Zendesk tickets</p>
                    <p className={'text-ebony_opacity_30 text-base-xs font-medium'}>
                      Teach your AI from solved tickets
                    </p>
                  </div>
                  {item && (
                    <div className={'flex items-center gap-7.5'}>
                      <div className={'cursor-pointer opacity-50 hover:opacity-100'}>
                        <EditKnowledgeBaseIntegrationModal
                          knowledgeBaseId={knowledgeBase.id}
                          trigger={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="15"
                              height="15"
                              viewBox="0 0 15 15"
                              fill="none"
                            >
                              <path
                                d="M1.66667 13.3306H2.845L10.6067 5.55634L9.42833 4.37609L1.66667 12.1504V13.3306ZM15 15H0V11.4584L11.1958 0.244385C11.3521 0.0879054 11.564 0 11.785 0C12.006 0 12.2179 0.0879054 12.3742 0.244385L14.7317 2.60572C14.8879 2.76224 14.9757 2.97451 14.9757 3.19584C14.9757 3.41717 14.8879 3.62944 14.7317 3.78597L5.2025 13.3306H15V15ZM10.6067 3.19584L11.785 4.37609L12.9633 3.19584L11.785 2.01559L10.6067 3.19584Z"
                                fill="#05050D"
                              />
                            </svg>
                          }
                          item={{ ...item, data: item }}
                        />
                      </div>
                      <div
                        className={
                          'cursor-pointer opacity-50 hover:opacity-100 transition [&_svg>path]:hover:fill-delete'
                        }
                      >
                        <DeleteKnowledgeBaseIntegrationModal
                          knowledgeBaseId={knowledgeBase.id}
                          item={{ ...item, data: item }}
                          trigger={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="17"
                              height="19"
                              viewBox="0 0 17 19"
                              fill="none"
                            >
                              <path
                                d="M1.9375 18V3.83333H1V1.94444H5.6875V1H11.3125V1.94444H16V3.83333H15.0625V18H1.9375ZM3.8125 16.1111H13.1875V3.83333H3.8125V16.1111ZM5.6875 14.2222H7.5625V5.72222H5.6875V14.2222ZM9.4375 14.2222H11.3125V5.72222H9.4375V14.2222Z"
                                fill="#05050D"
                                stroke="white"
                                strokeWidth="0.2"
                              />
                            </svg>
                          }
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </AccordionTrigger>
          <AccordionContent className="px-5 pb-0 max-w-[454px]"></AccordionContent>
        </AccordionItem>
      </Accordion>
      <div className={clsx('group pt-3.5', !disabled && 'invisible pointer-events-none')}>
        {isButtonsDisabled ? (
          <AddItemIconDisabled />
        ) : (
          <AddZendeskTicketsPopup
            disabled={isButtonsDisabled}
            knowledgeBaseId={knowledgeBase.id}
            trigger={<AddItemIcon />}
          />
        )}
      </div>
    </div>
  );
};
